export const METRIC_SERIES_TYPE = {
	BAR: 'bar',
	LINE: 'line',
};

const VALID_SERIES_TYPES = new Set(Object.values(METRIC_SERIES_TYPE));

export const isMetricSeriesBarType = (type) => type === METRIC_SERIES_TYPE.BAR;

export const normalizeMetricSeriesTypes = (metrics = [], input = {}, { defaultType = METRIC_SERIES_TYPE.LINE } = {}) => {
	const result = {};
	for (const metric of metrics) {
		const raw = input?.[metric];
		result[metric] = VALID_SERIES_TYPES.has(raw) ? raw : defaultType;
	}
	return result;
};

export const resolveMetricSeriesDefaultType = (chartType, isBarChartType) =>
	isBarChartType(chartType) ? METRIC_SERIES_TYPE.BAR : METRIC_SERIES_TYPE.LINE;

export const applyChartTypeToMetricSeriesTypes = (metrics = [], chartType, isBarChartType) =>
	normalizeMetricSeriesTypes(metrics, {}, {
		defaultType: resolveMetricSeriesDefaultType(chartType, isBarChartType),
	});

export const resolveMetricSeriesIsBar = (metric, seriesTypes = {}, chartType, isBarChartType) => {
	const normalized = normalizeMetricSeriesTypes([metric], seriesTypes, {
		defaultType: resolveMetricSeriesDefaultType(chartType, isBarChartType),
	});
	return isMetricSeriesBarType(normalized[metric]);
};

export const isMixedMetricSeriesTypes = (seriesTypes = {}) => {
	const values = Object.values(seriesTypes ?? {});
	if (values.length < 2) return false;
	const hasBar = values.some(isMetricSeriesBarType);
	const hasLine = values.some((type) => type === METRIC_SERIES_TYPE.LINE);
	return hasBar && hasLine;
};

export const toggleMetricSeriesType = (metrics = [], seriesTypes = {}, metric, chartType, isBarChartType) => {
	const normalized = normalizeMetricSeriesTypes(metrics, seriesTypes, {
		defaultType: resolveMetricSeriesDefaultType(chartType, isBarChartType),
	});
	const current = normalized[metric] ?? METRIC_SERIES_TYPE.LINE;
	return {
		...normalized,
		[metric]: current === METRIC_SERIES_TYPE.BAR ? METRIC_SERIES_TYPE.LINE : METRIC_SERIES_TYPE.BAR,
	};
};

export const serializeMetricSeriesTypes = (seriesTypes = {}) => {
	const entries = Object.entries(seriesTypes ?? {}).filter(([, type]) => VALID_SERIES_TYPES.has(type));
	if (!entries.length) return undefined;
	return entries.map(([metric, type]) => `${metric}:${type}`).join(',');
};

export const parseMetricSeriesTypes = (raw) => {
	if (!raw || typeof raw !== 'string') return {};
	const result = {};
	for (const part of raw.split(',')) {
		const [metric, type] = part.split(':');
		if (!metric || !VALID_SERIES_TYPES.has(type)) continue;
		result[metric.trim()] = type.trim();
	}
	return result;
};
